export default __webpack_public_path__ + "static/media/msf_s2.aad2da16.png";